import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_PRELOADED_CAMPAIGNS = createActionTypes('FETCH_PRELOADED_CAMPAIGNS');
export const GET_PRELOADED_CAMPAIGN = createActionTypes('GET_PRELOADED_CAMPAIGN');
export const CREATE_PRELOADED_CAMPAIGN = createActionTypes('CREATE_PRELOADED_CAMPAIGN');
export const UPDATE_PRELOADED_CAMPAIGN = createActionTypes('UPDATE_PRELOADED_CAMPAIGN');
export const DELETE_PRELOADED_CAMPAIGN = createActionTypes('DELETE_PRELOADED_CAMPAIGN');
export const DISBURSE_PRELOADED_CAMPAIGN = createActionTypes('DISBURSE_PRELOADED_CAMPAIGN');
